__turbopack_context__.v({
  "cartBtn": "Layout-module__sHDNXW__cartBtn",
  "footerLoader": "Layout-module__sHDNXW__footerLoader",
  "layoutContainer": "Layout-module__sHDNXW__layoutContainer",
  "loginBtn": "Layout-module__sHDNXW__loginBtn",
  "logo": "Layout-module__sHDNXW__logo",
  "mainContent": "Layout-module__sHDNXW__mainContent",
  "navActions": "Layout-module__sHDNXW__navActions",
  "navContent": "Layout-module__sHDNXW__navContent",
  "navLinks": "Layout-module__sHDNXW__navLinks",
  "searchBtn": "Layout-module__sHDNXW__searchBtn",
});
